<template>
  <div class="order-container">
    <ic-tab
      v-model="orderType"
      :items="[
        { text: $t('brand.type.conditional'), key: 'conditional' },
        { text: $t('brand.type.current'), key: 'current' },
      ]"
    />
    <div class="order-forms" :class="{ mobile: type !== '' }">
      <order-form
        type="buy"
        :selectedOrder="selectedOrder"
        :orderType="orderType"
        v-if="type === '' || type === 'buy'"
      />
    <order-form
        type="sell"
        :selectedOrder="selectedOrder"
        :orderType="orderType"
        v-if="type === '' || type === 'sell'"
      />
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import OrderForm from '../OrderForm'
export default {
  components: {
    OrderForm,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    selectedOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      orderType: 'conditional',
    }
  }
}
</script>

<style lang="scss">
@import './Order.scss';
</style>
